import dayjs from "dayjs"

export const Footer = () => {
  return (
    <footer>
      <div className="mx-auto max-w-7xl px-6 md:py-12 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex justify-center gap-x-6 md:order-2">
          <p className="mt-4 text-center text-sm/6 text-gray-600 dark:text-gray-300 md:order-1 md:mt-0">
            Created by{" "}
            <a
              href="https://matzielab.com"
              target="_blank"
              className="hover:underline hover:text-primary-500"
            >
              Matzielab
            </a>
          </p>
        </div>
        <p className="mb-4 text-center text-sm/6 text-gray-600 dark:text-gray-300 md:order-1 md:mb-0">
          &copy; {dayjs().format("YYYY")} Lovers Live Forever. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
